import { render, staticRenderFns } from "./DetailProjectHeader.vue?vue&type=template&id=359f8404"
import script from "./DetailProjectHeader.vue?vue&type=script&lang=js"
export * from "./DetailProjectHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports